import { render, staticRenderFns } from "./RsaPazienteStoricoStatiAccettazioneListComponent.vue?vue&type=template&id=05219f6c"
import script from "./RsaPazienteStoricoStatiAccettazioneListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteStoricoStatiAccettazioneListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports